import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedLoadingService } from './shared.loading.service';


@Injectable({
  providedIn: 'root'
})
export class SharedSnackBarHandlerService {

  constructor(
    private snackBar: MatSnackBar,
    private loader: SharedLoadingService
  ) { }

  public showError(error: string) {
    console.log(error);

    this.snackBar.open('Error', error, { duration: 3000 });
    this.loader.hide();
  }

  public showMessage(message: string, action: string) {
    this.snackBar.open(message,
      action,
      {
        duration: 2000
      });
    this.loader.hide();
  }

  public handleError(error) {
    console.log(error);

    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `${error.status}: ${error.statusText}`;
    }
    return throwError(errorMessage);
  }
}
